export const getType = (type) => {
    const typeMap = {
        act: 'a',
        guide: 'g',
        camp: 'c'
    };

    return typeMap[type] || '';
};

export const getTypeOrg = (type) => {
    const typeMap = {
        t: 'trip',
        g: 'gu',
        a: 'act',
        c: 'camp', // support URLs use /support/c/... for camps
        camp: 'camp'
    };
    return typeMap[type] || '';
};

export const getModeOrg = (type) => {
    const typeMap = {
        t: 'Trip',
        g: 'Guide',
        a: 'Activity',
        c: 'Camp',
        camp: 'Camp'
    };
    return typeMap[type] || '';
};

export const getTypeShort = (type) => {
    const typeMap = {
        activity: 'act',
        guide: 'gu',
        trip: 'trip',
        camp: 'camp'
    };
    return typeMap[type] || '';
};
